import SEO from "@/components/SEO";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import LocationsSection from "@/components/LocationsSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import InThePodSection from "@/components/InThePodSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import PartnerBand from "@/components/PartnerBand";
import Footer from "@/components/Footer";

/**
 * Consumer-first landing page. The traveler owns the page top to bottom and it
 * closes on social proof; venues and event organizers get a slim doorway and the
 * partnerships enquiry form as a clearly separated final block.
 *
 * PromoBanner, PositioningSection, FeaturesSection, FoundersSection, JavitsGallery,
 * and BoothSpecsSection are no longer rendered here. The components still exist.
 */
const Index = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Quiet Corner | Book a Private Workspace Pod"
        description="Book a soundproof workspace pod by the hour at the Javits Center, Grand Central, Penn Station, and Times Square in New York, and at Union Station in Washington, DC. Private space for calls, focus, and small meetings."
        path="/"
      />
      <Navbar />

      {/* Traveler path */}
      <HeroSection />
      <LocationsSection />
      <HowItWorksSection />
      <InThePodSection />
      <TestimonialsSection />

      {/* Partner path: one "let's connect" band at #partners, which the navbar links
          to. It closes with the enquiry form rather than handing off to another page. */}
      <PartnerBand />

      <Footer />
    </div>
  );
};

export default Index;
